import React, { FC, ReactNode } from "react";

import { useIntl } from "react-intl";

import { Alert } from "@mapmycustomers/ui";

import TextWithInfo from "@app/component/typography/TextWithInfo";

import styles from "./OutOfFrequencyAlert.module.scss";

export interface OutOfFrequencyAlertProps {}

const OutOfFrequencyAlert: FC<OutOfFrequencyAlertProps> = () => {
  const intl = useIntl();

  return (
    <Alert
      className={styles.container}
      message={
        <TextWithInfo
          className={styles.tooltipText}
          iconProps={{
            className: styles.icon,
          }}
          info={intl.formatMessage(
            {
              id: "dashboard.editModal.criteria.outOfFrequencyAlert.tooltip",
              defaultMessage:
                "<p>Records are considered out of frequency (or past due) when both of the following are true:</p><ul><li>The record has a set frequency or is part of a group with a frequency.</li><li>There has not been any valid activity on the record within the set frequency.</li></ul><p>For example, if a record has a frequency of 30 days and the last activity on it was 31 days ago, the record would be past.</p><p>You can learn more about frequencies <link>here</link>.</p>",
              description:
                "Description of the alert shown in some out of frequency charts to explain it",
            },
            {
              li: (text: ReactNode[]) => <li>{text}</li>,
              // TODO: add link later
              link: (text: ReactNode[]) => (
                <a
                  href="https://support.mapmycustomers.com/hc/en-us/articles/20776651228183-Frequencies"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {text}
                </a>
              ),
              p: (text: ReactNode[]) => <p>{text}</p>,
              ul: (text: ReactNode[]) => <ul>{text}</ul>,
            }
          )}
          tooltipOverlayClassName={styles.tooltip}
        >
          {intl.formatMessage({
            id: "dashboard.editModal.criteria.outOfFrequencyAlert",
            defaultMessage: "What does it mean when a record is out of frequency?",
            description: "Alert shown in some out of frequency charts to explain it",
          })}
        </TextWithInfo>
      }
    />
  );
};

export default OutOfFrequencyAlert;
